// Social platform catalog. Icons use Font Awesome brands (loaded via CDN in index.html).
export const SOCIAL_PLATFORMS = [
  { value: "instagram", label: "Instagram", icon: "fa-brands fa-instagram", placeholder: "https://instagram.com/yourhandle" },
  { value: "facebook", label: "Facebook", icon: "fa-brands fa-facebook", placeholder: "https://facebook.com/yourpage" },
  { value: "tiktok", label: "TikTok", icon: "fa-brands fa-tiktok", placeholder: "https://tiktok.com/@yourhandle" },
  { value: "youtube", label: "YouTube", icon: "fa-brands fa-youtube", placeholder: "https://youtube.com/@yourchannel" },
  { value: "x", label: "X (Twitter)", icon: "fa-brands fa-x-twitter", placeholder: "https://x.com/yourhandle" },
  { value: "threads", label: "Threads", icon: "fa-brands fa-threads", placeholder: "https://threads.net/@yourhandle" },
  { value: "pinterest", label: "Pinterest", icon: "fa-brands fa-pinterest", placeholder: "https://pinterest.com/yourhandle" },
  { value: "reddit", label: "Reddit", icon: "fa-brands fa-reddit", placeholder: "https://reddit.com/r/yoursub" },
  { value: "discord", label: "Discord", icon: "fa-brands fa-discord", placeholder: "https://discord.gg/invite" },
  { value: "whatsapp", label: "WhatsApp", icon: "fa-brands fa-whatsapp", placeholder: "https://wa.me/1XXXXXXXXXX" },
  { value: "snapchat", label: "Snapchat", icon: "fa-brands fa-snapchat", placeholder: "https://snapchat.com/add/yourhandle" },
  { value: "linkedin", label: "LinkedIn", icon: "fa-brands fa-linkedin", placeholder: "https://linkedin.com/company/yourco" },
  { value: "etsy", label: "Etsy", icon: "fa-brands fa-etsy", placeholder: "https://etsy.com/shop/yourshop" },
  { value: "email", label: "Email", icon: "fa-solid fa-envelope", placeholder: "mailto:you@nc-mycology.com" },
  { value: "website", label: "Website / Other", icon: "fa-solid fa-globe", placeholder: "https://..." },
];

const _map = Object.fromEntries(SOCIAL_PLATFORMS.map((p) => [p.value, p]));

export const socialIcon = (platform) => _map[platform]?.icon || "fa-solid fa-link";
export const socialLabel = (platform) => _map[platform]?.label || "Link";

// Ensures a value like "instagram.com/x" becomes a valid href.
export const normalizeUrl = (platform, url) => {
  const v = (url || "").trim();
  if (!v) return "#";
  if (platform === "email" && !v.startsWith("mailto:")) return `mailto:${v}`;
  if (/^https?:\/\//i.test(v) || v.startsWith("mailto:") || v.startsWith("tel:")) return v;
  return `https://${v}`;
};
